import React from 'react';
import { useSelector } from 'react-redux';
import { useApp, useMaps, useTime } from '../../_contexts';
import { ChronosDate } from '../../_helpers';
import { Icon } from '../../_components';

const DEFAULT_DATE_MASK = `$DD$ $MMMM$ $YYYY$`;

export function SidebarTimeline({ events, hideTitle, selectedEvent }) {
  const { calendar: defaultCalendar } = useTime();
  const { details: world } = useSelector((state) => state.world);

  const items = events
    ? events.map((ev) => {
        return (
          <SidebarTimelineEvent
            item={ev}
            key={ev._id}
            calendar={defaultCalendar}
            worldTime={world && world.worldTime ? world.worldTime : false}
          />
        );
      })
    : [];

  return (
    <React.Fragment>
      {items && items.length > 0 && (
        <div className="chronos-sidebar-timeline">
          {!hideTitle && (
            <h5 className="chronos-sidebar-subtitle chronos-sidebar-timeline-title">
              History
            </h5>
          )}
          <ul className="chronos-sidebar-timeline-list">
            {/* First Entry */}
            {selectedEvent !== undefined && (
              <SidebarTimelineEvent
                item={selectedEvent}
                fromDateOnly
                calendar={defaultCalendar}
                worldTime={world && world.worldTime ? world.worldTime : false}
              />
            )}

            {items}
            {/* Last Entry */}
            {selectedEvent !== undefined && (
              <SidebarTimelineEvent
                item={selectedEvent}
                toDateOnly
                calendar={defaultCalendar}
                worldTime={world && world.worldTime ? world.worldTime : false}
              />
            )}
          </ul>
        </div>
      )}
    </React.Fragment>
  );
}

function SidebarTimelineEvent({
  item,
  calendar,
  worldTime,
  fromDateOnly,
  toDateOnly,
}) {
  const { openSidebar } = useApp();
  const { currentMap, goTo, goToMap } = useMaps();
  const {
    // calendar,
    currentDate,
    granularity,
    unitsDisplay,
    setCurrentDate,
    updateScrollPosition,
  } = useTime();

  const handleItemClick = () => {
    // //Get Event Start Date
    // console.log('Adjusting Date to ', item.fromDate);
    // //Determine the scroll position (offset from 0px left)
    // const targetDate = new ChronosDate(item.fromDate, { calendar });
    // const segment = targetDate.getTimelineSegment(granularity, {
    //   unitCountDisplay: unitsDisplay,
    // });
    // const pos = targetDate.getPositionFromStart(segment.start, granularity);
    // console.log('Position?', pos);
    // if (currentDate !== segment.start) {
    //   setCurrentDate(segment.start);
    // }
    // updateScrollPosition(pos);
    //Set date and scrollposition
    //Move to MapMarker
    if (item.marker && item.marker.coords) {
      const { marker } = item;
      if (marker) {
        // console.log('Found Marker', marker, currentMap);
        if (currentMap._id !== marker.parentMap) {
          goToMap(marker.parentMap, marker.coords);
        } else {
          goTo(marker.coords);
        }
      }
    }
    openSidebar({
      type: 'event',
      payload: { event: item },
    });
  };

  let posSuffix = '';
  let negSuffix = '';

  if (worldTime) {
    let preAbbr = worldTime.beforeZeroAbbr;
    let postAbbr = worldTime.afterZeroAbbr;
    if (preAbbr && preAbbr.length > 0) {
      negSuffix = preAbbr;
    }
    if (postAbbr && postAbbr.length > 0) {
      posSuffix = postAbbr;
    }
  }

  const fromDate = new ChronosDate(item.fromDate, { calendar }).format(
    calendar.dateMask || DEFAULT_DATE_MASK,
    undefined,
    posSuffix,
    negSuffix
  );

  const toDate =
    item.toDate !== null
      ? new ChronosDate(item.toDate, { calendar }).format(
          calendar.dateMask || DEFAULT_DATE_MASK,
          undefined,
          posSuffix,
          negSuffix
        )
      : false;

  const showLabel = !toDateOnly && !fromDateOnly;
  return (
    <li className="chronos-sidebar-timeline-item" onClick={handleItemClick}>
      <div className="chronos-sidebar-timeline-event">
        <span className="chronos-sidebar-timeline-event-date">
          {item.fromDate && item.fromDate !== null && (
            <React.Fragment>
              {!toDateOnly && (
                <span className="chronos-date-display">{fromDate}</span>
              )}

              {toDate && !fromDateOnly && (
                <React.Fragment>
                  {/* <span className="chronos-date-separator">—</span> */}
                  {!toDateOnly && <Icon icon="far fa-chevron-right fa-fw" />}

                  <span className="chronos-date-display">{toDate}</span>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </span>
        {showLabel && (
          <React.Fragment>
            <h5 className="chronos-timeline-event-title">{item.title}</h5>
            <div className="chronos-timeline-event-excerpt">{item.excerpt}</div>
          </React.Fragment>
        )}
      </div>
    </li>
  );
}
